//api.js of memberships


import {API} from "../../../backend";
import { objectToQueryString } from "../../../lib/utils";



export const getMembership = (userId, token, membershipId) => {
    return fetch(`${API}/membership/${userId}/${membershipId}`,{
        method: "GET",
        headers:{
          Accept: "application/json",
          Authorization: `Bearer ${token}`
      },
    })
    .then(response => {
        return response.json();
    })
    .catch(err => { console.error(err); return { error: true, message: err?.message }; })
};

export const getAllMemberships=(userId,token,query)=>{
    let str=objectToQueryString(query);
    return fetch(`${API}/memberships/${userId}?${str}`,{
        method:'GET',
        headers:{
            Accept:"application/json",
            Authorization:`Bearer ${token}`
        }
    }).then(response=>{
        return response.json();
    }).catch(err => { console.error(err); return { error: true, message: err?.message }; })
};

export const getMembershipCount=(userId,token,query)=>{
    let str=objectToQueryString(query);
    return fetch(`${API}/memberships/count/${userId}?${str}`,{
        method:'GET',
        headers:{
            Accept:"application/json",
            Authorization:`Bearer ${token}`
        }
    }).then(response=>{
        return response.json();
    }).catch(err => { console.error(err); return { error: true, message: err?.message }; })
};


export const addDaysOnMembership=(userId,token,membershipId,body)=>{
    return fetch(`${API}/membership/add-days/${userId}/${membershipId}`,{
        method:'POST',
        headers:{
            Accept:"application/json",
            "Content-Type":"application/json",
            Authorization:`Bearer ${token}`
        },
        body:JSON.stringify(body)
    }).then(response=>{
        return response.json();
    }).catch(err => { console.error(err); return { error: true, message: err?.message }; })
};


export const changeMembershipDate=(userId,token,membershipId,body)=>{
    return fetch(`${API}/membership/change-date/${userId}/${membershipId}`,{
        method:'POST',
        headers:{
            Accept:"application/json",
            "Content-Type":"application/json",
            Authorization:`Bearer ${token}`
        },
        body:JSON.stringify(body)
    }).then(response=>{
        return response.json();
    }).catch(err => { console.error(err); return { error: true, message: err?.message }; })
};



export const editMembershipDate=(userId,token,membershipId,body)=>{
    return fetch(`${API}/edit-membership/${userId}/${membershipId}`,{
        method:'POST',
        headers:{
            Accept:"application/json",
            "Content-Type":"application/json",
            Authorization:`Bearer ${token}`
        },
        body:JSON.stringify(body)
    }).then(response=>{
        return response.json();
    }).catch(err => { console.error(err); return { error: true, message: err?.message }; })
};



export const cancelMemberships=(userId,token,body)=>{
    return fetch(`${API}/cancel-memberships/${userId}`,{
        method:'POST',
        headers:{
            Accept:"application/json",
            "Content-Type":"application/json",
            Authorization:`Bearer ${token}`
        },
        body:JSON.stringify(body)
    }).then(response=>{
        return response.json();
    }).catch(err => { console.error(err); return { error: true, message: err?.message }; })
};



export const transferMembership=(userId,token,membershipId,body)=>{
    return fetch(`${API}/transfer-membership/${userId}/${membershipId}`,{
        method:'POST',
        headers:{
            Accept:"application/json",
            "Content-Type":"application/json",
            Authorization:`Bearer ${token}`
        },
        body:JSON.stringify(body)
    }).then(response=>{
        return response.json();
    }).catch(err => { console.error(err); return { error: true, message: err?.message }; })
};



export const downloadMemberships=(userId,token,query)=>{
    let str=objectToQueryString(query);
    return fetch(`${API}/download-memberships/${userId}?${str}`,{
        method:'GET',
        headers:{
            Authorization:`Bearer ${token}`
        }
    }).then(response=>response.blob()).catch(err => { console.error(err); return { error: true, message: err?.message }; })
};

export const bulkUploadMemberships=(userId,token,branchId,body)=>{
    return fetch(`${API}/bulk-membership-upload/${userId}/${branchId}`,{
        method:'POST',
        headers:{
            Accept:"application/json",
            Authorization:`Bearer ${token}`
        },
        body:body
    }).then(response=>{
        return response.json();
    }).catch(err => { console.error(err); return { error: true, message: err?.message }; })
};


export const restoreCancelledMemberships=(userId,token,membershipId,body)=>{
    return fetch(`${API}/restore-cancelled-memberships/${userId}/${membershipId}`,{
        method:'POST',
        headers:{
            Accept:"application/json",
            Authorization:`Bearer ${token}`,
            "Content-Type":"application/json"
        },
        body:JSON.stringify(body)
    }).then(response=>{
        return response.json();
    }).catch(err => { console.error(err); return { error: true, message: err?.message }; })
};

export const generatePaymentLink = (userId,token,body)=>{
    return fetch(`${API}/razorpay/payment/${userId}`,{
        method:'POST',
        headers:{
            Accept:"application/json",
            Authorization:`Bearer ${token}`,
            "Content-Type":"application/json"
        },
        body:JSON.stringify(body)
    }).then(response=>{
        return response.json();
    }).catch(err => { console.error(err); return { error: true, message: err?.message }; })
};

export const getPaymentConfirmation = (userId,token,paymentId)=>{
    return fetch(`${API}/payment/confirm/${userId}/${paymentId}`,{
        method:'GET',
        headers:{
            Accept:"application/json",
            Authorization:`Bearer ${token}`
        },
    }).then(response=>{
        return response.json();
    }).catch(err => { console.error(err); return { error: true, message: err?.message }; })
};
